/**
 * KOMPA 2.0 — FAQ video library.
 * Each entry drives one card in the auto-rotating FAQ carousel on the
 * dashboard home tab. `gradient` gives every thumbnail a distinct dynamic
 * look while the video sits paused until the user taps play.
 */
const BASE = 'https://customer-assets.emergentagent.com/job_5d654389-bde7-4b84-b111-fedab2930415/artifacts';

export const FAQ_VIDEOS = [
  {
    id: 'que-es-kompa',
    question: '¿Qué es Kompa?',
    url: `${BASE}/ff727g8x_Que%20es%20Kompa.mp4`,
    gradient: 'from-[#1f2d5a] to-[#3b52a0]',
  },
  {
    id: 'aporte-indexado',
    question: '¿Qué significa que mi aporte esté indexado?',
    url: `${BASE}/sk5zs89q_Que%20significa%20que%20mi%20aporte%20este%CC%81%20INDEXADO.mp4`,
    gradient: 'from-[#fbb040] to-[#e0791f]',
  },
  {
    id: 'cambiar-meta',
    question: '¿Puedo cambiar de meta?',
    url: `${BASE}/v19ft7bx_Puedo%20cambiar%20de%20meta.mp4`,
    gradient: 'from-[#0f766e] to-[#14b8a6]',
  },
  {
    id: 'entregan-beneficio',
    question: '¿Cuándo me entregan mi beneficio?',
    url: `${BASE}/c9ehqd9r_Cuando%20me%20entregan%20mi%20beneficio.mp4`,
    gradient: 'from-[#7c3aed] to-[#a855f7]',
  },
  {
    id: 'donde-ubicados',
    question: '¿Dónde están ubicados?',
    url: `${BASE}/q5xmz5fp_Donde%20estan%20ubiados.mp4`,
    gradient: 'from-[#be123c] to-[#f43f5e]',
  },
  {
    id: 'quiero-retirar',
    question: '¿Y si me quiero retirar?',
    url: `${BASE}/wtldpq4i_Y%20si%20me%20quiero%20retirar.mp4`,
    gradient: 'from-[#1e293b] to-[#475569]',
  },
];
